<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="competencyValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.description')"
                name="description"
                :error="errors.get('description')"
            >
                <textarea class="form-control" rows="10"
                    :placeholder="$t('common.description')"
                    v-model="value.description"
                ></textarea>
            </base-input>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
        },

        created() {
            this.errors.setValidator('competencyValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
